import * as React from "react";
// CSS-only tooltip wrapper for a ref chip. The chip is keyboard-
// focusable so users navigating with Tab get the same tooltip as
// hover users. `role="tooltip"` + `aria-describedby` ties the bubble
// to the trigger for assistive tech.
export function RefChip({
  kind,
  tooltip,
  children,
}: {
  kind: "loc" | "d" | "p";
  tooltip: string;
  children: React.ReactNode;
}) {
  const tipId = `ref-tip-${React.useId()}`;
  return (
    <span className="ph-ref-tip">
      <span
        className="ph-bylaw"
        data-kind={kind}
        tabIndex={0}
        aria-describedby={tipId}
      >
        {children}
      </span>
      <span id={tipId} role="tooltip" className="ph-ref-tip-bubble">
        {tooltip}
      </span>
    </span>
  );
}
